<script>
import { forEach } from 'lodash';
import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import movePageOnSwipe from '@/components/movePageOnSwipe';
import shareBtn from '@/components/shareBtn';
import pageTitle from '@/components/pageTitle';
import snsIcons from '@/components/snsIcons';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.BIOGRAPHY,
  components: {
    commonFooter,
    commonNav,
    movePageOnSwipe,
    shareBtn,
    pageTitle,
    snsIcons,
  },
  data() {
    return {
      ready: false,
      members: [],
      explanation: [],
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,
      rightMoveto: { name: Constants.ROUTER.DISCOGRAPHY},
    };
  },
  created() {
    setMetaUtil.setMeta(this, document,
      `${this.$i18n.messages.ja.message.biography.pageName} - ${this.$i18n.messages.ja.message.bandName}`,
      this.$i18n.messages.ja.message.biography.description,
    );
    document.dispatchEvent(new Event('custom-render-trigger'));

    this.members = [];

    forEach(this.$t('message.biography.members.list'), (v, k) => {
      let obj = {
        name: v.name,
        roleList: v.role,
        twitter: v.twitter ? `https://twitter.com/${v.twitter}` : '',
        twitterId: v.twitter,
        instagram: v.instagram ? `https://www.instagram.com/${v.instagram}` : '',
        instagramId: v.instagram,
        bluesky: v.bluesky ? `https://bsky.app/profile/${v.bluesky}` : '',
        blueskyId: v.bluesky,
        threads: v.threads ? `https://www.threads.net/@${v.threads}` : '',
        threadsId: v.threads,
        key: k,
      };
      this.members.push(obj);
    });

    this.explanation = this.$t('message.biography.band.explanation').split('<br>').map((t) => {
      return t.trim();
    });
    
    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  },
};
</script>

<template>
  <move-page-on-swipe
    :is-left-move-to="false"
    :right-move-to="rightMoveto"
    class="view-biography page"
    :class="[ready ? 'is-ready' : '', $mq]"
  >
    <common-nav/>
    <div id="contents-main" :style="{'min-height': windowHeight + 'px'}">

      <page-title :title-text="$t('message.biography.pageName')" title-type="sun" />

      <div class="band-container">
        <div class="contents">
          <div class="title wf-gothicfont">{{this.$t('message.biography.band.title')}}</div>
          <snsIcons />
          <p v-for="(text, i) in explanation" :key="i"><span>{{text}}</span></p>
        </div>
      </div>

      <div class="member-container">
        <div class="member" v-for="member in members" :key="member.key">
          <div class="square">
            <div class="name">{{member.name}}</div>
            <div class="role">
              <div v-for="role in member.roleList" :key="role">{{role}}</div>
            </div>
            <div class="sns">
              <a
                v-if="member.twitter"
                class="icon twitter"
                :title="'@' + member.twitterId"
                :href="member.twitter"
                target="_blank"
              ></a>
              <a
                v-if="member.instagram"
                class="icon instagram"
                :title="'@' + member.instagramId"
                :href="member.instagram"
                target="_blank"
              ></a>
              <a
                v-if="member.bluesky"
                class="icon bluesky"
                :title="'@' + member.blueskyId"
                :href="member.bluesky"
                target="_blank"
              ></a>
              <a
                v-if="member.threads"
                class="icon threads"
                :title="'@' + member.threadsId"
                :href="member.threads"
                target="_blank"
              ></a>
            </div>
          </div>
        </div>
      </div>

    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </move-page-on-swipe>
</template>

<style lang="scss" scoped>
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      padding-top: $commonNavHeight * 2;
      .band-container {
        width: 100%;
        min-height: 500px;
        margin-top: 20px;
        .contents {
          width: 100%;
          height: 100%;
          min-height: 500px;
          padding: 50px 20px 50px 20px;
          background: url(../assets/img/decoration/biography01.svg) right bottom, $textColorA50;
          @include bg;
          p {
            transition: 3s ease-out;
            opacity: 0;
            transform: translate(-50px, 0);
          }
        }
      }
      .member-container {
        margin: 0 auto;
        flex-wrap: wrap;
        .member {
          .square {
            margin: auto;
            position: relative;
            background-color: $textColor;
            color: $bgColor;
            @include bgCenter;
            background-image: url(../assets/img/decoration/stamp01.svg);
            z-index: $zIndexBiographyMembers;
            text-align: left;
            .name {
              font-size: 1.5em;
            }
            .role {
              font-size: 0.9em;
            }
            .sns {
              position: absolute;
              bottom: 10px;
              left: 10px;
              right: 10px;
              display: flex;
              justify-content: flex-end;
              .icon {
                display: block;
                width: 30px;
                height: 30px;
                margin-left: 10px;
                cursor: pointer;
                @include bgCenter;
                transform: scale(1);
                transition: 0.1s linear;
                &:hover {
                  transform: scale(1.1) rotate(10deg);
                }
                &.twitter {background-image: url(../assets/img/sns/twitter.svg);}
                &.instagram {background-image: url(../assets/img/sns/instagram.svg);}
                &.bluesky {background-image: url(../assets/img/sns/bluesky.svg);}
                &.threads {background-image: url(../assets/img/sns/threads.svg);}
              }
            }
          }
          
        }
      }
    }

    &.is-ready {
      #contents-main{
        .band-container .contents p{
          transform: translate(0px, 0);
          opacity: 1;
        }
      }
    }
    // responsible -----------------------------------------------
    &.viewLg {
      #contents-main {
        .band-container {
          text-align: left;
          .contents {
            line-height: 40px;
            .title { font-size: 2em; }
          }
        }
        .member-container {
          width: 897px;
          height: 400px;
          display: flex;
          justify-content: center;
          .member {
            width: 282px;
            height: 200px;
            .square {
              width: 200px;
              height: 200px;
              padding: 5px;
              transform: rotate(-45deg);
            }
          }
        }
      }
    }
    &.viewMd {
      #contents-main {
        .band-container {
          .contents {
            line-height: 40px;
            .title { font-size: 1.7em; }
            p { margin-bottom: 20px; }
          }
        }
        .member-container {
          width: 90%;
          margin: auto;
          display: flex;
          justify-content: space-around;
          .member {
            width: 200px;
            height: 200px;
            margin: 30px 0;
            .square {
              width: 200px;
              height: 200px;
              padding: 5px;
            }
          }
        }
      }
    }
    &.viewSm {
      #contents-main {
        .band-container {
          .contents {
            line-height: 30px;
            .title { font-size: 1.5em; }
            p { margin-bottom: 20px; }
          }
        }
        .member-container {
          width: 90%;
          .member {
            width: 100%;
            height: 170px;
            margin: 30px auto;
            .square {
              width: 100%;
              height: 170px;
              padding: 5px;
              text-align: center;
            }
          }
        }
      }
    }
  }

</style>
